import axios from 'axios'

export default {
    getMenu: (type) => axios.get('menu/'+type),
}